module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Publications")]), _vm._v(" "), _c('h3', [_vm._v("Books")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "55%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(book) {
    return (book.type === 'book') ? _c('tr', [_c('td', [_vm._v("\n\n                        " + _vm._s(book.year) + "\n\n                    ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(book.title))]), _vm._v(" "), (book.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(book.coauthor) + ")\n                        ")]) : _vm._e(), _vm._v(" "), (book.note) ? _c('span', [_c('br'), _vm._v(_vm._s(book.note) + "\n                        ")]) : _vm._e()]), _c('td', [_vm._v("\n                        " + _vm._s(book.publisher) + "\n\n                    ")])]) : _vm._e()
  }))]), _vm._v(" "), _c('h3', [_vm._v("Peer Reviewed Articles")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(art) {
    return (art.type === 'peer review') ? _c('tr', [_c('td', [_vm._v("\n\n                        " + _vm._s(art.year) + "\n\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(art.title) + "\n\n                        "), (art.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(art.coauthor) + ")\n                        ")]) : _vm._e()]), _c('td', [_vm._v("\n                        " + _vm._s(art.journal) + "\n\n                    ")]), _c('td', [_vm._v("\n                        " + _vm._s(_vm.makeCitation(art)) + "\n\n                    ")])]) : _vm._e()
  }))]), _vm._v(" "), _c('h3', [_vm._v("Law Review Articles")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(art) {
    return (art.type === 'law review') ? _c('tr', [_c('td', [_vm._v("\n\n                        " + _vm._s(art.year) + "\n\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(art.title) + "\n\n                        "), (art.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(art.coauthor) + ")\n                        ")]) : _vm._e()]), _c('td', [_vm._v("\n                        " + _vm._s(art.journal) + "\n\n                    ")]), _c('td', [_vm._v("\n                        " + _vm._s(_vm.makeCitation(art)) + "\n\n                    ")])]) : _vm._e()
  }))]), _vm._v(" "), _c('h3', [_vm._v("Book Chapters")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "45%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(chapter) {
    return (chapter.type === 'chapter') ? _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(chapter.year) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(chapter.title) + "\n\n                        "), (chapter.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(chapter.coauthor) + ")\n                        ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(chapter.editor) + ", ed., "), _c('em', [_vm._v(_vm._s(chapter.book))]), _vm._v(" (" + _vm._s(chapter.publisher) + ")\n                        \n                    ")]), _c('td', [_vm._v("\n                        \n                        " + _vm._s(chapter.firstpage + "-" + chapter.lastpage) + "\n                    \n                    ")])]) : _vm._e()
  }))]), _vm._v(" "), _c('h3', [_vm._v("Book Reviews")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "35%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(rev) {
    return (rev.type === 'book review') ? _c('tr', [_c('td', [_vm._v("\n\n                        " + _vm._s(rev.year) + "\n\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(rev.title) + "\n\n                        "), (rev.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(rev.coauthor) + ")\n                        ")]) : _vm._e()]), _c('td', [_vm._v("\n                        " + _vm._s(rev.journal) + "\n\n                    ")]), _c('td', [_vm._v("\n                        " + _vm._s(_vm.makeCitation(rev)) + "\n\n                    ")])]) : _vm._e()
  }))]), _vm._v(" "), _c('h3', [_vm._v("Miscellany")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedPubs), function(misc) {
    return (misc.type === 'misc') ? _c('tr', [_c('td', [_vm._v("\n                        " + _vm._s(misc.year) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(misc.title) + "\n                        \n                        "), (misc.coauthor) ? _c('span', [_c('br'), _vm._v("(Co-Author with " + _vm._s(misc.coauthor) + ")\n                        ")]) : _vm._e()]), _c('td', [_vm._v("\n                        " + _vm._s(misc.note) + "\n                    ")])]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41684514","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/publications.vue
// module id = 191
// module chunks = 0